<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import { CasesService } from '@/types/generated/services.gen'
  import {
    type CustomerCase,
    type CustomerDataMapper as DataMapper
  } from '@/types/generated/types.gen'
  import router from '@/router'
  import '@tato30/vue-pdf/style.css'
  import TEMPORARYCaseBaseComponent from '@/components/app/cases/TEMPORARYCaseBaseComponent.vue'
  import AiChat from '@/components/app/cases/chat/AiChat.vue'

  const caseData = ref<CustomerCase | null>(null)
  const mappers = ref<DataMapper[]>([])

  const showAssistant = ref(false)
  onMounted(async () => {
    caseData.value = (await CasesService.casesRetrieve({
      uuid: router.currentRoute.value.params.uuid.toString()
    })) as CustomerCase
    mappers.value = (
      await CasesService.casesDatamappersList({
        uuid: router.currentRoute.value.params.uuid.toString()
      })
    ).results as DataMapper[]
  })

  const mainContentClasses = computed(() => ({
    'pr-[480px]': showAssistant.value,
    'transition-all duration-300 ease-in-out': true
  }))
</script>

<template>
  <div
    class="h-full w-full"
    :class="mainContentClasses"
  >
    <TEMPORARYCaseBaseComponent
      :mappers="mappers"
      :case-data="caseData"
    >
      <AiChat :case-data="caseData" />
    </TEMPORARYCaseBaseComponent>
  </div>
</template>
